module.exports = __webpack_public_path__ + "img/img6.453814ab.png";